import { useAuth } from "@/contexts/AuthContext";
import { CLUB } from "@/lib/club";
import { Hourglass, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col" data-testid="pending-screen">
      {/* Top bar with logout */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-[#27272A]">
        <div className="flex items-center gap-3">
          <img src={CLUB.logo} alt={CLUB.name} className="h-10 w-10 object-contain"/>
          <div>
            <div className="overline text-[#22d3ee]">{CLUB.city}</div>
            <div className="font-display text-xl text-white leading-none">{CLUB.name.toUpperCase()}</div>
          </div>
        </div>
        <button onClick={onLogout} className="btn-ghost text-xs flex items-center gap-2" data-testid="pending-logout">
          <LogOut size={14}/> Cerrar sesión
        </button>
      </div>

      {/* Center content */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-xl w-full text-center">
          {/* Hourglass icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 border-2 border-[#FF9F0A] mb-6" style={{ background: "rgba(255,159,10,0.08)" }}>
            <Hourglass size={36} className="text-[#FF9F0A]"/>
          </div>

          <div className="overline text-[#FF9F0A] mb-3">Cuenta en revisión</div>
          <h1 className="font-display text-4xl sm:text-5xl text-white leading-none">
            ¡BIENVENIDO A<br/>
            <span className="text-[#22d3ee]">FERROVIARIOS!</span>
          </h1>
          <p className="text-[#A1A1AA] mt-6 text-base leading-relaxed">
            Tu cuenta está <span className="text-white font-bold">en espera de aprobación</span>.
            Un administrador te asignará un rol pronto para que puedas acceder a la plataforma.
          </p>

          {/* User card */}
          <div className="mt-8 inline-flex items-center gap-3 px-5 py-3 border border-[#27272A] bg-[#121212]">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-10 h-10 object-cover"/>
            ) : (
              <div className="w-10 h-10 bg-[#1A1A1A] border border-[#27272A] flex items-center justify-center text-white font-bold">{user?.name?.[0]}</div>
            )}
            <div className="text-left">
              <div className="text-sm text-white font-bold">{user?.name}</div>
              <div className="text-xs text-[#A1A1AA]">{user?.email}</div>
            </div>
            <span className="badge badge-pending-role ml-2">Pendiente</span>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-0 border border-[#27272A]">
            <Step n="1" label="Inicio sesión" done/>
            <Step n="2" label="Aprobación admin" current/>
            <Step n="3" label="Acceso completo"/>
          </div>

          <p className="text-xs text-[#71717A] mt-8 uppercase tracking-widest">
            Esta página se actualizará automáticamente cuando tu cuenta sea activada.
          </p>
        </div>
      </div>
    </div>
  );
}

const Step = ({ n, label, done, current }) => (
  <div className={`p-4 border-r border-[#27272A] last:border-r-0 ${current ? "bg-[#1A1A1A]" : ""}`}>
    <div className={`font-display text-2xl leading-none ${done ? "text-[#34C759]" : current ? "text-[#FF9F0A]" : "text-[#3f3f46]"}`}>
      {done ? "✓" : n}
    </div>
    <div className={`text-[10px] uppercase tracking-widest mt-2 ${current ? "text-white" : "text-[#71717A]"}`}>{label}</div>
  </div>
);
